const SectionTypes = {
	CREATE_SECTION_START: 'create_section_start',
	CREATE_SECTION_SUCCESS: 'create_section_success',
	CREATE_SECTION_FAILURE: 'create_section_failure',
	CREATE_SECTION_KEY: 'CreateNewSectionFromWeb',
	UPDATE_SECTION_START: 'update_section_start',
	UPDATE_SECTION_SUCCESS: 'update_section_success',
	UPDATE_SECTION_FAILURE: 'update_section_failure',
	UPDATE_SECTION_KEY: 'UpdateSectionToken',
	GET_SECTIONS_BY_ORGANISATION_START: 'get_sections_by_organisation_start',
	GET_SECTIONS_BY_ORGANISATION_SUCCESS: 'get_sections_by_organisation_success',
	GET_SECTIONS_BY_ORGANISATION_FAILURE: 'get_sections_by_organisation_failure',
	GET_SECTIONS_BY_ORGANISATION_KEY: 'GetAllSectionByOrganisationIDWeb',
} as const;

export default SectionTypes;
